import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0b6154eb"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "todoComponent"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = {
  "class": "appsContainer__actionItems"
};
var _hoisted_4 = {
  "class": "appsContainer__actionItems-top"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("b", null, "Due Date", -1);
});
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("b", null, "Due By", -1);
});
var _hoisted_7 = {
  "class": "appsContainer__content"
};
var _hoisted_8 = {
  key: 0,
  "class": "appsContainer__list-item-done-label"
};
var _hoisted_9 = ["onClick"];
var _hoisted_10 = {
  "class": "appsContainer__actionItems"
};
var _hoisted_11 = {
  "class": "appsContainer__actionItems-top"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("b", null, "Due Date", -1);
});
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("b", null, "Due By", -1);
});
var _hoisted_14 = {
  "class": "appsContainer__content"
};
var _hoisted_15 = {
  key: 0,
  "class": "appsContainer__list-item-done-label"
};
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "flex-parent"
  }, [/*#__PURE__*/_createElementVNode("h3", null, "What Needs Done?")], -1);
});
var _hoisted_17 = {
  "class": "flex-parent"
};
var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "flex-parent"
  }, [/*#__PURE__*/_createElementVNode("h3", null, "When's it due?")], -1);
});
var _hoisted_19 = {
  "class": "flex-parent"
};
var _hoisted_20 = {
  "class": "flex-child flex-child-lg"
};
var _hoisted_21 = {
  "class": "flex-child flex-child-lg"
};
var _hoisted_22 = {
  "class": "flex-parent"
};
var _hoisted_23 = {
  "class": "flex-child flex-child-lg"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  var _component_Button = _resolveComponent("Button");
  var _component_ButtonBasic = _resolveComponent("ButtonBasic");
  var _component_AppsContainer = _resolveComponent("AppsContainer");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_AppsContainer, {
    title: "My",
    listATitle: "Still Open",
    listBTitle: "Closed",
    listCountA: $data.totalDone,
    listCountB: $data.totalNotDone
  }, {
    buttonIcon: _withCtx(function () {
      return [_createVNode(_component_font_awesome_icon, {
        icon: ['fad', 'clipboard-list-check']
      })];
    }),
    listB: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.todos, function (todo, index) {
        return _openBlock(), _createElementBlock("div", {
          key: todo.id,
          onClick: function onClick($event) {
            todo.done = !todo.done;
            $options.calculateTodoCounts();
          }
        }, [todo.done ? (_openBlock(), _createElementBlock("li", {
          key: 0,
          "class": _normalizeClass({
            'appsContainer__list-item': true,
            'appsContainer__list-item--done': todo.done
          })
        }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [todo.dueDate ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          "class": "appsContainer__item-action-button appsContainer__item-action-button--date"
        }, {
          "default": _withCtx(function () {
            return [_hoisted_5, _createTextVNode(" " + _toDisplayString(todo.dueDate), 1)];
          }),
          _: 2
        }, 1024)) : _createCommentVNode("", true), todo.dueTime ? (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          "class": "appsContainer__item-action-button appsContainer__item-action-button--date"
        }, {
          "default": _withCtx(function () {
            return [_hoisted_6, _createTextVNode(" " + _toDisplayString(todo.dueTime), 1)];
          }),
          _: 2
        }, 1024)) : _createCommentVNode("", true)]), !todo.done ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          label: _ctx.itemName,
          "class": "appsContainer__item-action-button appsContainer__item-action-button--notdone",
          onClick: function onClick($event) {
            todo.done = todo.done;
            $options.calculateTodoCounts();
          }
        }, {
          "default": _withCtx(function () {
            return [_createVNode(_component_font_awesome_icon, {
              icon: "fa-check",
              "class": "fas fa-check appsContainer__icon-trash"
            }), _createTextVNode(" Mark as Done ")];
          }),
          _: 2
        }, 1032, ["label", "onClick"])) : _createCommentVNode("", true), todo.done ? (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          label: _ctx.itemName,
          "class": "appsContainer__item-action-button appsContainer__item-action-button--done",
          onClick: function onClick($event) {
            todo.done = true;
            $options.calculateTodoCounts();
          }
        }, {
          "default": _withCtx(function () {
            return [_createVNode(_component_font_awesome_icon, {
              icon: "fa-check",
              "class": "fas fa-check appsContainer__icon-trash"
            }), _createTextVNode(" Undo Done ")];
          }),
          _: 2
        }, 1032, ["label", "onClick"])) : _createCommentVNode("", true), _createVNode(_component_Button, {
          label: _ctx.itemName,
          "class": "appsContainer__item-action-button appsContainer__item-action-button--delete",
          onClick: function onClick($event) {
            _ctx.$store.commit('deleteTodo', index);
          }
        }, {
          "default": _withCtx(function () {
            return [_createTextVNode(" Delete "), _createVNode(_component_font_awesome_icon, {
              icon: "fa-trash-alt",
              "class": "fas fa-phone appsContainer__icon-trash"
            })];
          }),
          _: 2
        }, 1032, ["label", "onClick"])]), _createElementVNode("div", _hoisted_7, _toDisplayString(todo.text), 1), todo.done ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Done!")) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true)], 8, _hoisted_2);
      }), 128))];
    }),
    listA: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.todos, function (todo, index) {
        return _openBlock(), _createElementBlock("div", {
          key: todo.id,
          onClick: function onClick($event) {
            todo.done = !todo.done;
            $options.calculateTodoCounts();
          }
        }, [todo.done == false ? (_openBlock(), _createElementBlock("li", {
          key: 0,
          "class": _normalizeClass({
            'appsContainer__list-item': true,
            'appsContainer__list-item--done': todo.done
          })
        }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [todo.dueDate ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          "class": "appsContainer__item-action-button appsContainer__item-action-button--date"
        }, {
          "default": _withCtx(function () {
            return [_hoisted_12, _createTextVNode(" " + _toDisplayString(todo.dueDate), 1)];
          }),
          _: 2
        }, 1024)) : _createCommentVNode("", true), todo.dueTime ? (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          "class": "appsContainer__item-action-button appsContainer__item-action-button--date"
        }, {
          "default": _withCtx(function () {
            return [_hoisted_13, _createTextVNode(" " + _toDisplayString(todo.dueTime), 1)];
          }),
          _: 2
        }, 1024)) : _createCommentVNode("", true)]), !todo.done ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          label: _ctx.itemName,
          "class": "appsContainer__item-action-button appsContainer__item-action-button--notdone",
          onClick: function onClick($event) {
            todo.done = todo.done;
            $options.calculateTodoCounts();
          }
        }, {
          "default": _withCtx(function () {
            return [_createVNode(_component_font_awesome_icon, {
              icon: "fa-check",
              "class": "fas fa-check appsContainer__icon-trash"
            }), _createTextVNode(" Mark as Done ")];
          }),
          _: 2
        }, 1032, ["label", "onClick"])) : _createCommentVNode("", true), todo.done ? (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          label: _ctx.itemName,
          "class": "appsContainer__item-action-button appsContainer__item-action-button--done",
          onClick: function onClick($event) {
            todo.done = true;
            $options.calculateTodoCounts();
          }
        }, {
          "default": _withCtx(function () {
            return [_createVNode(_component_font_awesome_icon, {
              icon: "fa-check",
              "class": "fas fa-check appsContainer__icon-trash"
            }), _createTextVNode(" Undo Done ")];
          }),
          _: 2
        }, 1032, ["label", "onClick"])) : _createCommentVNode("", true), _createVNode(_component_Button, {
          label: _ctx.itemName,
          "class": "appsContainer__item-action-button appsContainer__item-action-button--delete",
          onClick: function onClick($event) {
            _ctx.$store.commit('deleteTodo', index);
          }
        }, {
          "default": _withCtx(function () {
            return [_createTextVNode(" Delete "), _createVNode(_component_font_awesome_icon, {
              icon: "fa-trash-alt",
              "class": "fas fa-phone appsContainer__icon-trash"
            })];
          }),
          _: 2
        }, 1032, ["label", "onClick"])]), _createElementVNode("div", _hoisted_14, _toDisplayString(todo.text), 1), todo.done ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Done!")) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true)], 8, _hoisted_9);
      }), 128))];
    }),
    addNewForm: _withCtx(function () {
      return [_hoisted_16, _createElementVNode("div", _hoisted_17, [_withDirectives(_createElementVNode("input", {
        "class": "appsContainer__input lex-child-lg",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return $data.newTodoText = $event;
        }),
        placeholder: "Add new todo"
      }, null, 512), [[_vModelText, $data.newTodoText]])]), _hoisted_18, _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createTextVNode(" Due Date"), _withDirectives(_createElementVNode("input", {
        "class": "appsContainer__input",
        type: "date",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return $data.dueDate = $event;
        })
      }, null, 512), [[_vModelText, $data.dueDate]])]), _createElementVNode("div", _hoisted_21, [_createTextVNode(" Time "), _withDirectives(_createElementVNode("input", {
        "class": "appsContainer__input",
        type: "time",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return $data.dueTime = $event;
        })
      }, null, 512), [[_vModelText, $data.dueTime]])])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createVNode(_component_ButtonBasic, {
        label: "Add Todo Item",
        "class": "todoComponent__button",
        onClick: _cache[3] || (_cache[3] = function ($event) {
          $options.addTodo();
          $options.calculateTodoCounts();
        })
      })])])];
    }),
    _: 1
  }, 8, ["listCountA", "listCountB"])]);
}